import { useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

// Color palette (reuse from Login.js if needed)
const colors = {
  deepOrange: '#E06207',
  burntOrange: '#A65007',
  oliveBrown: '#604B0C',
  reddishBrown: '#9C2E04',
  freshGreen: '#12B14A',
};

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1: verify, 2: set new password
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [userId, setUserId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!mobile || !name) {
      setError("Please enter both mobile and name");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("/auth/forgot-password/verify", {
        mobile,
        name,
      });
      setUserId(res.data.userId);
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || "User not found");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!newPassword || !confirmPassword) {
      setError("Please enter and confirm new password");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await axios.post("/auth/forgot-password/reset", {
        userId,
        newPassword,
      });
      setSuccess("Password updated successfully! Redirecting to login...");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="w-full max-w-md bg-white/90 backdrop-blur-sm shadow-2xl rounded-2xl p-8 border border-white/20">
        <h2 className="text-2xl font-bold mb-6 text-center" style={{ color: colors.deepOrange }}>
          Forgot Password
        </h2>
        {error && (
          <div className="mb-4 p-3 rounded-lg text-sm text-white" style={{ backgroundColor: colors.reddishBrown }}>
            {error}
          </div>
        )}
        {success && (
          <div className="mb-4 p-3 rounded-lg text-sm text-white" style={{ backgroundColor: colors.freshGreen }}>
            {success}
          </div>
        )}
        {step === 1 && (
          <form onSubmit={handleVerify} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: colors.oliveBrown }}>
                Registered Mobile Number
              </label>
              <input
                type="text"
                value={mobile}
                onChange={e => setMobile(e.target.value)}
                placeholder="Enter your mobile number"
                className="w-full px-3 py-2 rounded border focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: colors.oliveBrown }}>
                Registered Name
              </label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Enter your registered name"
                className="w-full px-3 py-2 rounded border focus:outline-none"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full py-2 rounded font-semibold text-white"
              style={{ background: `linear-gradient(135deg, ${colors.deepOrange}, ${colors.burntOrange})` }}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
          </form>
        )}
        {step === 2 && (
          <form onSubmit={handleReset} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: colors.oliveBrown }}>
                New Password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                className="w-full px-3 py-2 rounded border focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: colors.oliveBrown }}>
                Confirm New Password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                className="w-full px-3 py-2 rounded border focus:outline-none"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full py-2 rounded font-semibold text-white"
              style={{ background: `linear-gradient(135deg, ${colors.deepOrange}, ${colors.burntOrange})` }}
              disabled={loading}
            >
              {loading ? "Updating..." : "Set New Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
